import { Cell } from 'components/Datatable';
import sliceDate, { roundFloat } from 'utils/helper';

const balanceLogsColumns = [
  {
    minWidth: 150,
    Header: 'Message',
    accessor: 'message',
    Cell: ({ row }) => {
      const { message } = row.original;

      return <Cell content={message} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Balance',
    accessor: 'sum',
    Cell: ({ row }) => {
      const { sum } = row.original;
      const floatSum = roundFloat(sum);
      return <Cell content={floatSum} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Amount Before',
    accessor: 'amountBefore',
    Cell: ({ row }) => {
      const { amountBefore } = row.original;
      const floatAmount = roundFloat(amountBefore);

      return <Cell content={floatAmount} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Amount',
    accessor: 'amount',
    Cell: ({ row }) => {
      const { amount } = row.original;
      const floatAmount = roundFloat(amount);

      return <Cell content={floatAmount} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Exchange Rate',
    accessor: 'exchangeRate',
    Cell: ({ row }) => {
      const { exchangeRate } = row.original;

      return <Cell content={exchangeRate} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Exchange Currency',
    accessor: 'exchangeCurrency',
    Cell: ({ row }) => {
      const { exchangeCurrency } = row.original;

      return <Cell content={exchangeCurrency} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Source',
    accessor: 'source',
    Cell: ({ row }) => {
      const { source } = row.original;

      return <Cell content={source} />;
    },
  },
  {
    minWidth: 150,
    Header: 'Created At',
    accessor: 'createdAt',
    Cell: ({ row }) => {
      const { createdAt } = row.original;

      return <Cell content={sliceDate(createdAt)} />;
    },
  },
];

export default balanceLogsColumns;
